import { useTranslation } from "react-i18next";
import Footer from "@/components/Footer";
import { HeroSection } from "../components/newLanding/HeroSection";
import { ToolkitSection } from "../components/newLanding/ToolkitSection";
import { AutomationTracksSection } from "../components/newLanding/AutomationTracksSection";
import { StepsSection } from "../components/newLanding/StepsSection";
import { WhySection } from "../components/newLanding/WhySection";
import { FaqSection } from "../components/newLanding/FaqSection";

export default function NewLandingPage() {
  // Keep translation hook if hero aria-label required
  const { t } = useTranslation(["newLanding"]);
  return (
    <main
      aria-label={t("hero.title")}
      className="flex flex-col w-full min-h-screen bg-background"
    >
      <HeroSection />
      <ToolkitSection />
      <AutomationTracksSection />
      <StepsSection />
      <WhySection />
      <FaqSection />
      <Footer />
    </main>
  );
}
